<template>
  <div>
    <LeftSide
      :status="leftSideStatus"
      :keyName="filterProps.name"
      :keyStatus="filterProps.status"
      @filtrate="filtrate"
      @batchSearch="batchSearch"
    />
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <Header
        :batchBool="batchBool"
        :keyName="filterProps.name"
        :keyStatus="filterProps.status"
        @clearKey="clearKey"
        :isAccordion="isAccordionProduct"
        @accordionProducts="accordionProducts"
        @addNew="addNew"
      />
      <router-view
        v-if="isSysRights('SupplierProductCategorys.findBySupplier')"
        :first_loading="firstLoading"
        :items="items"
        :isAccordion="isAccordionProduct"
        @addNew="addNew"
        @deletes="deletes"
        @togglesChange="togglesChange"
        @move="move"
        @addLabel="addLabel"
        @editSub="editSub"
        @getProductByCid="getProductByCid"
        :keyName="filterProps.name"
        :keyStatus="filterProps.status"
      ></router-view>
      <no-rights v-else></no-rights>
      <api-loading :show="loading"></api-loading>
      <Modal
        :modalId="'modalAddLabel'"
        :home="false"
        :loading="modalAddLabel.loading"
        :size="'md'"
        :autoH="false"
      >
        <template slot="header">
          <div class="modal-header pd-y-20 pd-x-25">
            <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
              {{ $t("mall.添加新标签") }}
            </h6>
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
        </template>
        <template slot="body">
          <div class="body-inner">
            <div class="form-group row mg-b-30">
              <label class="col-md-3 col-form-label form-control-sm text-right">
                {{ $t("mall.标签名称：") }}
              </label>
              <div
                class="
                  col-md-8 col-sm-12
                  d-flex
                  align-items-center
                  pd-0
                  mg-l-10
                "
              >
                <input
                  type="text"
                  :placeholder="$t('mall.请输入标签名称')"
                  name="name"
                  id="name"
                  class="form-control form-control-sm"
                  v-model="modalAddLabel.name"
                />
              </div>
            </div>
            <div class="form-group row">
              <label class="col-md-3 col-form-label form-control-sm text-right">
                {{ $t("mall.是否在商城显示：") }}
              </label>
              <div class="col-md-8 col-sm-12 d-flex align-items-center pd-0">
                <label class="rdiobox mg-b-0 mg-l-10">
                  <input
                    :disabled="modalAddLabel.disabled"
                    type="radio"
                    value="1"
                    name="isShow"
                    v-model="modalAddLabel.isShow"
                  />
                  <span class="pd-0">{{ $t("mall.显示") }}</span>
                </label>
                <label class="rdiobox mg-b-0 mg-l-10">
                  <input
                    type="radio"
                    value="2"
                    name="isShow"
                    v-model="modalAddLabel.isShow"
                  />
                  <span class="pd-0">{{ $t("mall.不显示") }}</span>
                </label>
              </div>
            </div>
          </div>
        </template>
        <template slot="footer">
          <div class="modal-footer d-block pd-y-15 pd-x-0">
            <div
              class="
                form-group
                row
                align-items-center
                justify-content-end
                pd-x-25
                mg-b-0
              "
            >
              <button
                type="button"
                class="
                  mg-r-15
                  btn btn-primary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                @click="addNewFn"
              >
                {{ $t("mall.保存") }}
              </button>
              <button
                type="button"
                class="
                  btn btn-secondary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                data-dismiss="modal"
              >
                {{ $t("mall.取消") }}
              </button>
            </div>
          </div>
        </template>
      </Modal>
      <confirmComponent
        @del_index_i="deletesFn"
        :modal_id="delAddr.modalId"
        :modal_title="delAddr.title"
        :modal_text="delAddr.text"
        :del_index="delAddr.delIndex"
      ></confirmComponent>
      <modalMallLabel
        :group_list="items"
        :open="modalMallLabelOpen"
        @saveMallLabel="saveMallLabel"
      ></modalMallLabel>
      <Modal
        :modalId="'modalGetProduct'"
        :home="false"
        :loading="modalGetProduct.loading"
        :size="'lg'"
        :autoH="false"
      >
        <template slot="header">
          <div class="modal-header pd-y-20 pd-x-25">
            <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
              {{ $t("mall.已绑定商品") }}
            </h6>
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
        </template>
        <template slot="body">
          <div class="body-inner">
            <div class="list-wrap mg-b-15">
              <div class="list-heard d-flex mg-b-5">
                <div class="pd-l-5 d-flex justify-content-center">
                  <label class="ckbox">
                    <input
                      type="checkbox"
                      :checked="isAll"
                      @change="changeAllCheck($event)"
                    />
                    <span></span>
                  </label>
                </div>
                <div class="d-flex pd-x-5 flex-1">
                  <div class="c-16">{{ $t("mall.商品信息") }}</div>
                  <div class="c-4">{{ $t("mall.状态") }}</div>
                  <div class="c-4">{{ $t("mall.操作") }}</div>
                </div>
              </div>
              <div
                class="list-body d-flex mg-b-10"
                v-for="item in modalGetProduct.items"
                :key="item.id"
              >
                <div class="pd-l-5 d-flex justify-content-center">
                  <label class="ckbox mg-b-0">
                    <input
                      type="checkbox"
                      :value="item.relationId"
                      v-model="modalGetProduct.checkArr"
                    /><span></span>
                  </label>
                </div>
                <div class="flex-1 pd-x-5 product-table card bd-gray-400 pd-5">
                  <div class="d-flex align-items-center">
                    <div class="c-16">
                      <div class="d-flex overflow-hidden">
                        <a
                          class="mg-r-10 img-wrap d-block"
                          href="javascript:;"
                          v-lazy:background-image="item.majorImgUrl"
                        ></a>
                        <div class="pro-info">
                          <div class="tx-ellipsis2">
                            {{ $t("mall.商品标题：") }}
                            <span class="">{{ item.name }}</span>
                          </div>
                          <div class="">
                            <div v-if="item.sku">
                              SKU：
                              <span class="">
                                {{ item.sku }}
                                <a
                                  href="javascript:;"
                                  class="tx-info to-clipboard"
                                  :data-clipboard-text="item.sku"
                                >
                                  <i class="icon ion-clipboard"></i>
                                </a>
                              </span>
                            </div>
                          </div>
                          <div v-if="item.propertyValue" class="tx-ellipsis1">
                            {{ $t("mall.属性：")
                            }}<span class="">{{ item.propertyValue }}</span>
                          </div>
                          <div v-if="item.categoryPath" class="tx-ellipsis1">
                            {{ $t("mall.分类：")
                            }}<span class="">{{ item.categoryPath }}</span>
                          </div>
                          <div>
                            {{ $t("mall.销售价格：")
                            }}<span class=""
                              >￥ {{ item.min ? fixed(item.min) : "0.00" }} ~ ￥
                              {{ item.max ? fixed(item.max) : "0.00" }}</span
                            >
                          </div>
                          <div>
                            {{ $t("mall.7天/30天销量：")
                            }}<span class=""
                              >{{ item.sold7days }} /
                              {{ item.sold30days }}</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="c-4 d-flex tx-g">
                      <div>
                        <span
                          :class="item.status == 2 ? 'tx-danger' : 'tx-success'"
                          >{{ $t(modalGetProduct.status[item.status]) }}</span
                        >
                      </div>
                    </div>
                    <div class="c-4">
                      <a
                        @click="unbindCategory(item.relationId)"
                        class="tx-info"
                        href="javascript:;"
                        >{{ $t("mall.解除关联") }}</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <innerPagination
                v-if="modalGetProduct.items.length > 0"
                :cur="modalGetProduct.page"
                :all="modalGetProduct.totalPage"
                :size="7"
                @page="gotoPageModal"
              ></innerPagination>
            </div>
          </div>
        </template>
        <template slot="footer">
          <div class="modal-footer d-block pd-y-15 pd-x-0">
            <div
              class="
                form-group
                row
                align-items-center
                justify-content-end
                pd-x-25
                mg-b-0
              "
            >
              <button
                :disabled="modalGetProduct.checkArr.length == 0"
                type="button"
                class="
                  mg-r-15
                  btn btn-primary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                @click="unbindCategory(modalGetProduct.checkArr)"
              >
                {{ $t("mall.批量解除关联") }}
              </button>
              <button
                type="button"
                class="
                  btn btn-secondary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                data-dismiss="modal"
              >
                {{ $t("mall.取消") }}
              </button>
            </div>
          </div>
        </template>
      </Modal>
      <batch-search-dialog @handleBatchSearch="handleBatchSearch" :dialog="batchSearchDialog" v-if="batchSearchDialog.visible == true"></batch-search-dialog>
    </div>
  </div>
</template>

<script>
import LeftSide from "./left-side.vue"; //$t('mall.左边栏')
import Header from "./header.vue"; //$t('mall.头')
import Modal from "@components/Modal";
import { innerPagination } from "@components/pagination.js"; //$t('mall.分页')
import { confirmComponent } from "@components/components.js"; //$t('mall.$t('mall.删除')确认')
import modalMallLabel from "./modal-mall-label.vue";
import BatchSearchDialog from '../../distributor/batch-search-dialog.vue'

export default {
  data() {
    return {
      batchSearchDialog:{
        visible: false,
        key: '',
      },
      batchSearchParams: {},
      batchBool: false,
      leftSideStatus: store.get("leftSideStatus"), //$t('mall.左边栏')$t('mall.状态')
      firstLoading: true,
      loading: false,
      page: this.$route.params.page ? this.$route.params.page : 1,
      totalPage: 1,
      rowsPerPage: parseInt(store.get("mall-label-rowsPerPage"))
        ? parseInt(store.get("mall-label-rowsPerPage"))
        : 10,
      pageSizeSelect: [10, 20, 50],
      totalCount: 0,
      items: [],
      filterProps: {
        name: "",
        status: "",
      },
      isAccordionProduct: store.get("isAccordionProduct-mall-label")
        ? store.get("isAccordionProduct-mall-label")
        : false,
      modalAddLabel: {
        loading: false,
        id: "",
        name: "",
        type: "",
        isShow: "1",
        disabled: false,
      },
      delAddr: {
        modalId: "modalDelLabel",
        title: this.$t("mall.删除标签"),
        text: this.$t("mall.确定要删除该标签吗"),
        delIndex: "",
      },
      modalMallLabelOpen: Symbol(),
      modalMallLabelId: "",
      modalGetProduct: {
        loading: false,
        id: "",
        items: [],
        checkArr: [],
        status: arrDict.storageProStataus,
        page: 1,
        rowsPerPage: 10,
        totalPage: 1,
        totalCount: "",
      },
      modalGetProductDefault: "{}",
    };
  },
  components: {
    BatchSearchDialog,
    LeftSide,
    Header,
    Modal,
    innerPagination,
    confirmComponent,
    modalMallLabel,
  },
  watch: {
    $route: "gotoPage",
    rowsPerPage: function () {
      store.set("mall-label-rowsPerPage", this.rowsPerPage);
    },
  },
  mounted() {
    //展开折叠搜索
    let user = store.get("userInfo");
    let that = this;
    if (this.$parent.sideTop) {
      if ($(".br-subleft").outerHeight() > 56) {
        $(".br-subleft").addClass("left-more ht-54 ht-auto");
        $(".br-subleft").append(
          `<a href="javascript:;" class="d-flex align-items-center more-btn"><span class=" mg-r-5 tx-info">${this.$t(
            "app.更多"
          )}</span><i aria-hidden="true" class="tx-info fa fa-angle-down"></i></a>`
        );
        $(".more-btn").on("click", function () {
          if ($(this).find("i").hasClass("fa-angle-down")) {
            $(this).find("span").text(that.$t("app.隐藏"));
            $(this).parent(".br-subleft").removeClass("ht-54");
            $(this)
              .find("i")
              .removeClass("fa-angle-down")
              .addClass("fa-angle-up");
          } else {
            $(this).find("span").text(that.$t("app.更多"));
            $(this).parent(".br-subleft").addClass("ht-54");
            $(this)
              .find("i")
              .addClass("fa-angle-down")
              .removeClass("fa-angle-up");
          }
          let bodyH = parseInt($(window).height());
          if (user.source == 9) {
            if ($("body").hasClass("side-top")) {
              let ht = $(".br-subleft").outerHeight();
              $(".body-wrap").css("height", bodyH - 340 - ht + "px");
            } else {
              $(".body-wrap").css("height", bodyH - 340 + "px");
            }
          } else {
            if ($("body").hasClass("side-top")) {
              let ht = $(".br-subleft").outerHeight();
              $(".body-wrap").css("height", bodyH - 260 - ht + "px");
            } else {
              $(".body-wrap").css("height", bodyH - 260 + "px");
            }
          }
        });
      }
    }
    this.modalGetProductDefault = JSON.stringify(this.modalGetProduct);
    this.getItems();
  },
  updated() {},
  computed: {
    isAll() {
      return this.modalGetProduct.checkArr.length ==
        this.modalGetProduct.items.length &&
        this.modalGetProduct.items.length > 0
        ? true
        : false;
    },
  },
  methods: {
    batchSearch(key){
      this.batchSearchDialog = {
        visible: true,
        key: key
      }
    },
    fixed(val) {
      return Number(val).toFixed(2);
    },
    unbindCategory(id) {
      let arr = [];
      if (Array.isArray(id)) {
        arr = id;
      } else {
        arr.push(id);
      }
      this.modalGetProduct.loading = true;
      $.api_call(
        "api.SupplierProductCategorys.unbindCategory",
        {
          relationIds: arr,
        },
        (r) => {
          this.modalGetProduct.loading = false;
          if (r.ErrorCode == "9999") {
            ShowTip(this.$t("mall.解除关联成功"), "success");
            this.gotoPageModal(1);
            this.updateItems(this.modalGetProduct.id);
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    gotoPageModal(page) {
      this.modalGetProduct.page = page;
      this.modalGetProduct.loading = true;
      $.api_call(
        "api.SupplierProductCategorys.getProductByCid",
        {
          page: page,
          rowsPerPage: this.modalGetProduct.rowsPerPage,
          id: this.modalGetProduct.id,
        },
        (r) => {
          this.modalGetProduct.loading = false;
          if (r.ErrorCode == "9999") {
            this.modalGetProduct.items = r.Data.Results;
            this.modalGetProduct.totalPage = r.Data.Pagination.totalPage;
            this.modalGetProduct.totalCount = r.Data.Pagination.totalCount;
            $("#modalGetProduct .modal-body").scrollTop(0);
            this.modalGetProduct.checkArr = [];
            if (this.modalGetProduct.items.length == 0) {
              $("#modalGetProduct").modal("hide");
            }
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    minPrice(item) {
      let price = 0;
      if (item.virtualSku && item.virtualSku.length) {
        price = Number(item.virtualSku[0].price);
      } else {
        return "0.00";
      }
      item.virtualSku.forEach((e) => {
        if (Number(e.price) < price) {
          price = Number(e.price);
        }
      });
      return price.toFixed(2);
    },
    maxPrice(item) {
      let price = 0;
      if (item.virtualSku && item.virtualSku.length) {
        price = Number(item.virtualSku[0].price);
      } else {
        return "0.00";
      }
      item.virtualSku.forEach((e) => {
        if (Number(e.price) > price) {
          price = Number(e.price);
        }
      });
      return price.toFixed(2);
    },
    changeAllCheck(e) {
      this.modalGetProduct.checkArr = [];
      if (e.target.checked) {
        this.modalGetProduct.items.forEach((e) => {
          this.modalGetProduct.checkArr.push(e.relationId);
        });
      }
    },
    getProductByCid(item) {
      this.modalGetProduct.items = "";
      this.modalGetProduct.loading = false;
      this.modalGetProduct.id = item.id;
      this.loading = true;
      $.api_call(
        "api.SupplierProductCategorys.getProductByCid",
        {
          page: 1,
          rowsPerPage: this.modalGetProduct.rowsPerPage,
          id: this.modalGetProduct.id,
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            this.modalGetProduct.items = r.Data.Results;
            this.modalGetProduct.totalPage = r.Data.Pagination.totalPage;
            this.modalGetProduct.totalCount = r.Data.Pagination.totalCount;
            $("#modalGetProduct").modal("show");
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    saveMallLabel(data) {
      this.loading = true;
      $.api_call(
        "api.SupplierProductCategorys.copyByCid",
        {
          fromId: this.modalMallLabelId,
          toId: data,
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            this.getItems();
            $("#modalMallLabels").modal("hide");
            ShowTip(this.$t("mall.复制商品到其他标签成功"), "success");
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    addLabel(item) {
      this.modalMallLabelId = item.id;
      this.modalMallLabelOpen = Symbol();
      $("#modalMallLabels").modal("show");
    },
    move(item, type) {
      //$t('mall.上移下移')
      let tx =
        type == 1 ? this.$t("mall.标签上移成功") : this.$t("mall.标签下移成功");
      this.loading = true;
      $.api_call(
        "api.SupplierProductCategorys.moveBySupplier",
        {
          id: item.id,
          type: type,
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            this.getItems();
            ShowTip(tx, "success");
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    togglesChange(item) {
      this.loading = true;
      $.api_call(
        "api.SupplierProductCategorys.changeBySupplier",
        {
          id: item.id,
          isShow: item.isShow == 1 ? 2 : 1,
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            this.getItems();
            ShowTip(this.$t("mall.标签设置成功"), "success");
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    deletesFn() {
      //$t('mall.删除')
      this.loading = true;
      $.api_call(
        "api.SupplierProductCategorys.deleteBySupplier",
        {
          id: this.delAddr.delIndex,
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            this.getItems();
            $(`#${this.delAddr.modalId}`).modal("hide");
            ShowTip(this.$t("mall.标签删除成功"), "success");
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    deletes(item) {
      //打开$t('mall.删除')
      let vm = this;
      this.delAddr.delIndex = item.id;
      $("#" + this.delAddr.modalId).modal("show");
    },
    addNewFn() {
      //$t('mall.保存')添加修改标签
      this.modalAddLabel.loading = true;
      let param = {
        name: this.modalAddLabel.name,
        isShow: this.modalAddLabel.isShow,
      };
      let url;
      let text;
      if (this.modalAddLabel.type) {
        //$t('mall.添加子标签')
        param.pid = this.modalAddLabel.id;
        url = "api.SupplierProductCategorys.addBySupplier";
        text = this.$t("mall.添加子标签成功");
      } else {
        if (this.modalAddLabel.id) param.id = this.modalAddLabel.id;
        url = this.modalAddLabel.id
          ? "api.SupplierProductCategorys.changeBySupplier"
          : "api.SupplierProductCategorys.addBySupplier";
        text = this.modalAddLabel.id
          ? this.$t("mall.修改新标签成功")
          : this.$t("mall.添加新标签成功");
      }
      $.api_call(url, param, (r) => {
        this.modalAddLabel.loading = false;
        if (r.ErrorCode == "9999") {
          ShowTip(text, "success");
          $("#modalAddLabel").modal("hide");
          if (this.modalAddLabel.id) {
            this.updateItems(this.modalAddLabel.id);
          } else {
            this.getItems();
            localStorage.setItem("addNewLabelSuccess", moment().unix());
          }
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    addNew(item, type) {
      //$t('mall.打开添加修改标签')
      if (type) {
        //$t('mall.添加子标签')
        this.modalAddLabel.type = type;
        this.modalAddLabel.name = "";
        this.modalAddLabel.id = item.id;
        this.modalAddLabel.isShow = item.isShow;
        this.modalAddLabel.disabled = item.isShow == 2 ? true : false;
      } else {
        this.modalAddLabel.type = "";
        if (item && item.id) {
          this.modalAddLabel.isShow = item.isShow;
          this.modalAddLabel.name = item.name;
          this.modalAddLabel.id = item.id;
        } else {
          this.modalAddLabel.name = "";
          this.modalAddLabel.id = "";
        }
      }

      this.modalAddLabel.loading = false;
      $("#modalAddLabel").modal("show");
    },
    editSub(item, sub) {
      this.modalAddLabel.type = "";
      this.modalAddLabel.disabled = item.isShow == 2 ? true : false;
      this.modalAddLabel.isShow = item.isShow == 2 ? 2 : sub.isShow;
      this.modalAddLabel.name = sub.name;
      this.modalAddLabel.id = sub.id;
      this.modalAddLabel.loading = false;
      $("#modalAddLabel").modal("show");
    },
    accordionProducts(type) {
      //$t('mall.商品折叠')
      store.set("isAccordionProduct-mall-label", type);
      this.isAccordionProduct = type;
      //    this.items.forEach((e, i) => {
      //      this.innerTableStatus(e);
      //    });
    },
    handleBatchSearch(item){
      this.batchSearchParams = item
      this.batchBool = true
      this.getItems()
    },

    //todo
    getItems(batch) {
      if (!this.isSysRights("SupplierProductCategorys.findBySupplier")) return;
      if(batch == 'common'){
        this.batchBool = false
      }
      this.loading = true;
      let params = {}
      if(Object.keys(this.batchSearchParams).length !== 0 && this.batchBool){
        params = {
          batchSearch: this.batchSearchParams,
        }
      }
      $.api_call("api.SupplierProductCategorys.findBySupplier", params, (r) => {
        this.loading = false;
        if (r.ErrorCode == "9999") {
          if(Object.keys(this.batchSearchParams).length !== 0){
              this.batchSearchDialog.visible = false
          }
          this.firstLoading = false;
          this.items = r.Data.Results;
          $("html,body").scrollTop(0);
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    updateItems(id) {
      this.loading = true;
      $.api_call(
        "api.SupplierProductCategorys.findBySupplier",
        {
          id: id,
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            if (r.Data.Results.length == 0) return;
            this.items.forEach((e, i) => {
              if (e.id == r.Data.Results[0].id) {
                this.items.splice(i, 1, r.Data.Results[0]);
              }
            });
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    clearKey(type) {
      this.filterProps[type] = "";
      if(type== "batchBool") {
        this.getItems('common');
        return
      }
      this.toPage(1);
    },
    filtrate(name, status) {
      (this.filterProps = {
        name,
        status,
      }),
        this.toPage(1);
    },
    changeRPPage(num) {
      let page = this.page;
      this.rowsPerPage = num;
      this.page = 1;
      this.$router.push({ path: "/mall-label/" + 1 });
      if (page == 1) {
        this.getItems();
      }
    },
    toPage(num) {
      let page = this.page;
      this.$router.push({ path: "/mall-label/" + num });
      if (page == num) {
        this.getItems('common');
      }
    },
    gotoPage() {
      this.page = this.$route.params.page ? this.$route.params.page : 1;
      this.getItems();
    },
  },
};
</script>

<style lang="less" scoped>
.body-inner {
  [data-id="datepicker-from"],
  [data-id="datepicker-to"] {
    background-color: #fff;
    border-color: rgba(0, 0, 0, 0.15);
    color: #495057;
  }
  ul {
    padding: 0;
    list-style: none;
    margin-bottom: 0;
  }
}
.nav.nav-outline {
  padding: 0 15px;
}
.list-body {
  .img-wrap {
    min-width: 80px;
    min-height: 80px;
    width: 80px;
    height: 80px;
    background-size: cover;
    background-position: center;
    border: 1px #ddd solid;
  }
}
#modalGetProduct .list-body {
  border-top: 1px solid #ddd;
  align-items: center;
  margin: 0;
}
#modalGetProduct .card {
  box-shadow: none;
}
#modalGetProduct .d-flex.overflow-hidden {
  align-items: center;
}
</style>